import { render, staticRenderFns } from "./DokumentyUpload.vue?vue&type=template&id=35bfc79d&"
import script from "./DokumentyUpload.vue?vue&type=script&lang=js&"
export * from "./DokumentyUpload.vue?vue&type=script&lang=js&"
import style0 from "./DokumentyUpload.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\azagent\\_work\\3\\s\\master-v3\\Filip.Client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('35bfc79d')) {
      api.createRecord('35bfc79d', component.options)
    } else {
      api.reload('35bfc79d', component.options)
    }
    module.hot.accept("./DokumentyUpload.vue?vue&type=template&id=35bfc79d&", function () {
      api.rerender('35bfc79d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/DokumentyUpload.vue"
export default component.exports